import React from 'react';
import { useContext } from 'react';
import styled from 'styled-components';

import { Container, ButtonAsync as Button, TitleWrapper, Text, BoxWrapper } from '../design';
import { PageContext } from '../PageProvider';

const CourseWrapper = styled.div`
    margin-bottom: 20px;
`;

const ListWrapper = styled.div`
    margin-bottom: 20px;
`;

const InstructorWrapper = styled.div`
    margin-bottom: 20px;
`;

const SubmitBtnWrapper = styled.div`
    overflow: auto;
`;

const ListHeader = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    border-bottom: 1px solid #eeeeee;
    padding-bottom: 10px;
`;

const HeaderItem = styled(Text)`
    color: #757575;
`;

const ContentRowWrapper = styled.div`
    max-height: 300px;
    overflow: auto;
`;

const ContentRows = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    padding: 10px 0px;
`;

const Cell = styled(Text)``;

const Review = ({ data, onSubmit }) => {
    const { reviewData } = useContext(PageContext);
    const { course, instructors, students } = reviewData;

    return (
        <Container>
            <TitleWrapper>Review</TitleWrapper>
            <BoxWrapper>
                <CourseWrapper>
                    <ListHeader>
                        <HeaderItem>School</HeaderItem>
                        <HeaderItem>Faculty</HeaderItem>
                        <HeaderItem>Course</HeaderItem>
                        <HeaderItem>Section</HeaderItem>
                        <HeaderItem>Semester</HeaderItem>
                    </ListHeader>
                    <ContentRows>
                        <Cell>{course.school}</Cell>
                        <Cell>{course.faculty}</Cell>
                        <Cell>{course.name}</Cell>
                        <Cell>{course.section}</Cell>
                        <Cell>{course.semester}</Cell>
                    </ContentRows>
                </CourseWrapper>
                <InstructorWrapper>
                    <ListHeader>
                        <HeaderItem>Instructor</HeaderItem>
                        <HeaderItem>Username</HeaderItem>
                        <HeaderItem>Password</HeaderItem>
                    </ListHeader>
                    <ContentRowWrapper>
                        {instructors.map((i) => (
                            <ContentRows key={i.username}>
                                <Cell>{i.name}</Cell>
                                <Cell>{i.username}</Cell>
                                <Cell>{i.password}</Cell>
                            </ContentRows>
                        ))}
                    </ContentRowWrapper>
                </InstructorWrapper>
                <ListWrapper>
                    <ListHeader>
                        <HeaderItem>Student ID</HeaderItem>
                        <HeaderItem>Name</HeaderItem>
                        <HeaderItem>Group</HeaderItem>
                        <HeaderItem>Username</HeaderItem>
                        <HeaderItem>Password</HeaderItem>
                    </ListHeader>
                    <ContentRowWrapper>
                        {students.map((s) => {
                            return (
                                <ContentRows key={s.studentId}>
                                    <Cell>{s.studentId}</Cell>
                                    <Cell>{s.name}</Cell>
                                    <Cell>{s.group}</Cell>
                                    <Cell>{s.username}</Cell>
                                    <Cell>{s.password}</Cell>
                                </ContentRows>
                            );
                        })}
                    </ContentRowWrapper>
                </ListWrapper>
                <SubmitBtnWrapper>
                    <Button
                        onClick={() => onSubmit(true)}
                        style={{ float: 'right', marginLeft: '20px', width: '180px' }}
                        buttonText='Submit and Download'
                    />
                    <Button id={'au_courseSubmit'} onClick={onSubmit} style={{ float: 'right' }} buttonText='Submit' />
                </SubmitBtnWrapper>
            </BoxWrapper>
        </Container>
    );
};

export default Review;
